var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8578 13.489V17.189C18.8578 20.309 15.9478 22.839 12.3578 22.839C8.76779 22.839 5.85779 20.309 5.85779 17.189V13.489C5.85779 16.609 8.76779 18.839 12.3578 18.839C15.9478 18.839 18.8578 16.609 18.8578 13.489Z",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8578 8.48911C18.8578 9.39911 18.6078 10.2391 18.1678 10.9591C17.0978 12.7191 14.8978 13.8391 12.3578 13.8391C9.81779 13.8391 7.61779 12.7191 6.54779 10.9591C6.10779 10.2391 5.85779 9.39911 5.85779 8.48911C5.85779 6.92911 6.58778 5.51911 7.75778 4.49911C8.93778 3.46911 10.5578 2.83911 12.3578 2.83911C14.1578 2.83911 15.7778 3.46911 16.9578 4.48911C18.1278 5.51911 18.8578 6.92911 18.8578 8.48911Z",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8578 8.48911V13.4891C18.8578 16.6091 15.9478 18.8391 12.3578 18.8391C8.76779 18.8391 5.85779 16.6091 5.85779 13.4891V8.48911C5.85779 5.36911 8.76779 2.83911 12.3578 2.83911C14.1578 2.83911 15.7778 3.46911 16.9578 4.48911C18.1278 5.51911 18.8578 6.92911 18.8578 8.48911Z",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.54edddc7ad09417364bf07a5813c5e1e.svg";
export { ForwardRef as ReactComponent };